import { memo, useContext } from "react";
import { ObjectContext } from "@providers/ObjectProvider";
import ObjectRelationshipCard from "./ObjectRelationshipCard";
import Table from '@mui/joy/Table';
import Stack from '@mui/joy/Stack';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import Typography from '@mui/joy/Typography';
import { gradientTint } from "@utils/gradientTint";
import { sortByDate } from "@utils/sorters";
import { formatDate } from "@utils/dates";
import { useAuth } from "@providers/AuthProvider";

export const ObjectPrimaryInfo = memo(function ObjectPrimaryInfo({
    cardHeader = null,
    tint,
    title,
    hideTitle = true,
    fields,
}) {
    const data = useContext(ObjectContext);
    const {user, can} = useAuth();


    return (
    <ObjectRelationshipCard
      unpadded

      sx={{
        '--mm-card-height': '10000px',
      }}
      title={!hideTitle && (
        <CardOverflow
          sx={theme => ({
            borderTopLeftRadius: 'calc(var(--Card-childRadius) + var(--variant-borderWidth))',
            borderTopRightRadius: 'calc(var(--Card-childRadius) + var(--variant-borderWidth))',
            marginBlockStart: 'var(--CardOverflow-offset)',
            ...gradientTint(theme, tint),
          })}
        >
          <CardActions
            sx={theme => ({
              py: 1.5,
            })}
          >
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={0.5}
            >
              <Typography sx={theme => ({flex: 1, fontWeight: '600', color: 'white' })}>{title}</Typography>
            </Stack>
          </CardActions>
        </CardOverflow>
      )}
    >
      {cardHeader != null && cardHeader}
      <Table
        // stickyHeader
        stripe="odd"
        // hoverRow
        sx={{
          margin: 0,
          padding: 0,
          tableLayout: 'auto',
        }}
      >
        <tbody>
        {fields.map((row, rowIndex) => {
            if(row.hasOwnProperty('conditional')) {
                if(typeof row.conditional === 'boolean' && typeof row.content !== 'string') {
                    return <em>row content cannot be a function with a simple truthy conditional</em>
                }

                // general truthy check
                if(
                    typeof row.conditional === 'boolean'
                    && row.conditional === true
                    && !data[row.content]
                ) {
                    return null;
                }

                // fn truthy check
                if(
                    typeof row.conditional === 'function'
                    && row.conditional(data, {user, can}) !== true
                ) {
                    return null;
                }
            }

            const content = typeof row.content === 'string' ? data[row.content] : row.content(data, row.label);

            return (
                <tr key={rowIndex}>
                    {row.label && (
                        <td className="min">
                            <Typography fontSize={'sm'} fontWeight={'bold'}>{row.label}</Typography>
                        </td>
                    )}
                    <td className="max" colSpan={row.label ? 1 : 2}>
                        <Typography fontSize={'sm'}>
                            {content}
                        </Typography>
                        {/* <Typography fontSize={'sm'}>&mdash; {formatDate(row.created_at)} (<ObjectPreview to={`/contacts/${row.contact_id}`} type="contact" object={{id: row.contact_id}}>{row.sent_by_name}</ObjectPreview>)</Typography> */}
                    </td>
                </tr>
            )
        })}
        </tbody>
      </Table>
    </ObjectRelationshipCard>
  );
});
